module.exports = __webpack_public_path__ + "578d86b21f21a3bd6525d9663ac5afe4.fbx";